import { useNavigate } from 'react-router-dom'
import { UserPlus } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { rutaAltaDesdeInscripcion } from '@/core/lib/inscripcion'
import { usePermissions } from '@/hooks/usePermissions'
import { puedeTocarTarea, type TareaPropiedad } from '@/lib/permisos-guard'

/** Marca de una tarea de nueva inscripción. Violeta, porque verde, rojo, naranja y ámbar ya tienen otro significado en Tareas. */
export function InscripcionBadge() {
  return (
    <Badge variant="outline" className="text-xs whitespace-nowrap bg-violet-100 text-violet-800 border-violet-200 dark:bg-violet-900 dark:text-violet-300 dark:border-violet-800">
      Nueva inscripción
    </Badge>
  )
}

/**
 * Aviso de una inscripción completada sin cliente, con el botón que lleva al alta y precarga el
 * CUIT. No se muestra sin permiso para crear clientes ni a quien no puede tocar la tarea.
 */
export function AltaPendienteDeInscripcion({ tarea }: { tarea: TareaPropiedad & { id: string } }) {
  const navigate = useNavigate()
  const { puede, emailUsuario } = usePermissions()
  if (!puede.crearCliente || !puedeTocarTarea(tarea, puede, emailUsuario)) return null

  return (
    <div className="flex items-center justify-between gap-3 rounded-md border border-violet-200 bg-violet-50 p-3 dark:border-violet-800 dark:bg-violet-950">
      <p className="text-sm">La inscripción está completada y el cliente todavía no se dio de alta.</p>
      <Button size="sm" onClick={() => navigate(rutaAltaDesdeInscripcion(tarea.id))}>
        <UserPlus className="h-4 w-4 mr-1" />
        Dar de alta el cliente
      </Button>
    </div>
  )
}
